// @ts-nocheck
import type { FileRejection } from "react-dropzone";

import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";

import { formatData } from "@onair/utils/format-number";

import { varAlpha } from "@onair/config-mui/styles";

import { fileData } from "../../file-thumbnail";

// ----------------------------------------------------------------------

type Props = {
  files: FileRejection[];
};

export function RejectionFiles({ files }: Props) {
  if (!files.length) {
    return null;
  }

  const renderMessage = (code: string) => {
    if (code === "file-invalid-type") {
      return "Định dạng không hợp lệ.";
    }
    if (code === "file-too-large") {
      return "Dung lượng tệp quá lớn.";
    }
    if (code === "file-too-small") {
      return "Dung lượng tệp quá nhỏ.";
    }
    return "Bạn đã quá số lượng tệp tải lên.";
  };

  return (
    <Paper
      variant="outlined"
      sx={{
        py: 1,
        px: 2,
        mt: 3,
        textAlign: "left",
        borderStyle: "dashed",
        borderColor: "error.main",
        bgcolor: (theme) =>
          varAlpha(theme.vars.palette.error.mainChannel, 0.08),
      }}
    >
      {files.map(({ file, errors }) => {
        const { path, size } = fileData(file);

        return (
          <Box key={path} sx={{ my: 1 }}>
            <Typography variant="subtitle2" noWrap>
              {path} - {size ? formatData(size) : ""}
            </Typography>

            {errors.map((error) => (
              <Box
                key={error.code}
                component="span"
                sx={{
                  typography: "caption",
                  wordBreak: "break-all",
                  display: "block",
                }}
              >
                - {renderMessage(error.code)}
              </Box>
            ))}
          </Box>
        );
      })}
    </Paper>
  );
}
